import { DatePipe, DecimalPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AccountService } from '../../../../Services/Accounts/account.service';

@Component({
  selector: 'app-cashflow',
  standalone: true,
  imports: [NgIf, NgFor, DecimalPipe, DatePipe, NgClass],
  templateUrl: './cashflow.component.html',
  styleUrl: './cashflow.component.css'
})
export class CashflowComponent implements OnChanges {
  @Input() firmId: any;
  @Input() isGst: boolean = true;
  @Input() fromDate: string = '';
  @Input() toDate: string = '';
  @Output() balancesLoaded = new EventEmitter<any[]>();

  isLoading = false;
  openingBalance = 0;
  transactions: any[] = [];
  summary = {
    amount_in: { cash: 0, bank: 0, card: 0, online: 0, disc: 0, total: 0 },
    amount_out: { cash: 0, bank: 0, card: 0, online: 0, disc: 0, total: 0 },
    opening_balance: 0,
    closing_balance: 0
  };

  showDenominationPopup = false;

  constructor(private accountService: AccountService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['firmId'] || changes['fromDate'] || changes['toDate']) {
      this.loadCashflow();
    }
  }

  loadCashflow() {
    this.isLoading = true;
    const params = {
      firm_id: this.firmId,
      from_date: this.fromDate,
      to_date: this.toDate
    };

    this.accountService.getDaybookCashflow(params).subscribe({
      next: (res: any) => {
        this.openingBalance = res.data.opening_balance;
        this.transactions = res.data.transactions || [];
        this.summary = res.data.summary;
        this.balancesLoaded.emit(res.data.account_balances || []);
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading cashflow', err);
        this.isLoading = false;
      }
    });
  }

  openDenomination() {
    this.showDenominationPopup = true;
  }

  closeDenomination() {
    this.showDenominationPopup = false;
  }
}
